import IPlayerProgressData from 'Player/PlayerProperty/Progress/IPlayerProgressData';
import IPlayerSettingsData from 'Player/PlayerProperty/Settings/IPlayerSettingsData';
import IPlayerInventoryData from 'Player/Inventory/IPlayerInventoryData';
import { LevelType } from './Progress/PlayerLevels';
import { IPlayerSocialState, IPlayerState } from './IPlayerState';
import { initialPetsState } from './Pets/initialPetsState';
import { PreBoosterType } from '../Card/BoosterType';
import { INITIAL_PREMIUM_SPINS_AMOUNT } from 'Constants/Player';
import { initialFarmPlayerState } from './Farm/initialFarmPlayerState';

export const initialPlayerInventory: IPlayerInventoryData = {
    wheelSpins: 0,
    shopGift: 0,
    coins: 0,
    keys: 0,
    [PreBoosterType.REMOVE_THREE]: 2,
    [PreBoosterType.JOKER]: 2,
    [PreBoosterType.CANISTER]: 2,
};

export const initialPlayerProgress: IPlayerProgressData = {
    totalAdsWatched: 0,
    starChestInitialStars: 0,
    dailyLoginRewardsClaimed: [],
};
export const initialPlayerSettings: IPlayerSettingsData = {
    audioMusic: true,
    audioSfx: true,
    cinematicMode: false,
};
export const initialPlayerSocial: IPlayerSocialState = {
    receivedMessages: [],
    friendData: [],
    friendCount: 0,
};
export const initialPlayerState: IPlayerState = {
    inventory: initialPlayerInventory,
    progress: initialPlayerProgress,
    settings: initialPlayerSettings,
    social: initialPlayerSocial,
    timers: new Map<string, Date>(),
    quests: [],
    eventQuests: [],
    petsState: initialPetsState,
    farmState: initialFarmPlayerState,
    unlockedBoosters: [],
    premiumWheelResetLevel: 0,
    premiumWheelSpinsAmount: INITIAL_PREMIUM_SPINS_AMOUNT,

    // Progress
    levels: {
        [LevelType.Core]: [],
    },
    fields: [],
    starChestLevel: null,
    petLevel: null,
    luckyTurnipsState: null,
    maxWorld: 1,
    FTUX: [],
    lastClaimedSpinLevel: 0,

    // If player had spun first time the wheels
    spunFirstNormalWheel: false,
    spunFirstDiamondWheel: false,

    isFbInstantUnified: false,

    tasks: [],
    FBEvents: [],
    usedCheats: false,
    purchases: 0,
    realMoneySpent: 0,
    coinValueBoughtWithRealMoney: 0,
    sessionCount: 0,
    lastSundayOfferPurchaseTimestamp: 0,
    totalSessionCount: 0,
    botOptIn: false,
    hasShortcut: false,

    /** Acts as the default restore value */
    attributionCampaignID: 'ORGANIC',
    gdprCompliance: false,

    productsPurchased: {},
    decoItemsRewarded: [],
    decoItemsSeen: [],

    deviceId: null,
    facebookUserId: null,

    missionAttempts: 0,
    missionAttemptsStartTimestamp: null,
    plusFiveBoostersUsed: 0,

    otherGameIds: [],
    currentEventOffer: null,
};
